@if (hasControl()) {
  <form [formGroup]="fG">
    <ejs-checkbox
      [formControlName]="fCN"
      [labelPosition]="labelPosition"
      [value]="value"
      [label]="label"
      [checked]="!!fG.controls[fCN].value"
      [indeterminate]="indeterminate"
      [cssClass]="cssClass + (showErrorState && fG.controls[fCN].invalid && fG.controls[fCN].dirty ? ' e-error' : '')"
    ></ejs-checkbox>
    <ng-content />
  </form>
} @else {
  <ejs-checkbox
    [labelPosition]="labelPosition"
    [value]="value"
    [label]="label"
    [checked]="checked"
    [indeterminate]="indeterminate"
    [disabled]="disabled"
    [cssClass]="cssClass"
    (change)="onStandaloneChange($event)"
  ></ejs-checkbox>
  <ng-content />
}
